<interacta-ai-panel-layout>
    <!-- HEADER -->
    <div
        animate.enter="animate-fade-in-panel"
        class="flex shrink-0 items-center gap-x-8 px-12 py-16 motion-reduce:animate-none"
    >
        @if (pageStack().length > 0) {
            <button
                class="shrink-0"
                interacta-icon-button
                type="button"
                [icon]="'arrow-left'"
                [label]="'SHARED.BUTTON.BACK' | translate"
                (click)="back()"
            ></button>
        } @else {
            <button
                class="shrink-0"
                interacta-icon-button
                type="button"
                [icon]="'hamburger'"
                [label]="'AI.SIDE_PANEL.OPEN_SETTINGS' | translate"
                (click)="navigate('settings')"
            ></button>
        }
        <div
            class="flex min-w-0 grow items-center gap-x-4 overflow-x-hidden typo-sm-bold"
        >
            @if (pageTitle(); as title) {
                <span class="min-w-0 truncate">{{ title | translate }}</span>
            } @else if (currentView() === null) {
                @if (chatTitle()) {
                    <span class="min-w-0 truncate">{{ chatTitle() }}</span>
                } @else {
                    <interacta-image
                        alt=""
                        [classes]="'size-24'"
                        [loading]="'eager'"
                        [src]="
                            currentThemeMode() === 'dark'
                                ? './assets/shared/images/ai/ai-interacta-logo_dark.svg'
                                : './assets/shared/images/ai/ai-interacta-logo_light.svg'
                        "
                    />
                    <span class="truncate">AInteracta</span>
                }
            }
        </div>
        <button
            class="shrink-0"
            interacta-icon-button
            type="button"
            [icon]="expandedSidebar() ? 'collapse-width' : 'expand-width'"
            [label]="
                (expandedSidebar()
                    ? 'UI.BUTTON.MINIMIZE'
                    : 'UI.BUTTON.MAXIMIZE'
                ) | translate
            "
            (click)="expandSidebar.emit(!this.expandedSidebar())"
        ></button>
        <button
            class="shrink-0"
            interacta-icon-button
            type="button"
            [icon]="'close'"
            [label]="'AI.CLOSE' | translate"
            (click)="closePanel()"
        ></button>
    </div>
    <!-- /HEADER -->

    <!-- BODY -->
    <div
        class="relative flex min-h-0 w-full grow flex-col overflow-hidden rounded-b-[23px]"
    >
        <interacta-ai-convo-chat-area
            class="flex min-h-0 grow flex-col"
            [attr.inert]="activeView() !== 'chat' ? '' : null"
            [currentThemeMode]="currentThemeMode()"
            [currentUser]="currentUser()"
        />

        <!-- SETTINGS OVERLAY -->
        @if (settingsRendered()) {
            <div
                class="absolute inset-0 z-10 transition-transform ease-in-out"
                [attr.inert]="activeView() !== 'settings' ? '' : null"
                [ngClass]="{
                    'translate-x-0': showSettings(),
                    'translate-x-full': !showSettings(),
                }"
                [style.transition-duration.ms]="ANIMATION_DURATION"
            >
                <interacta-ai-convo-settings-panel
                    class="size-full"
                    (agentSelected)="onAgentSelected($event)"
                    (historyItemClick)="onHistoryItemClick($event)"
                    (historyItemDelete)="onDeleteItem($event)"
                    (historyItemRename)="onRenameItem($event)"
                    (newChat)="onNewChatFromSettings()"
                    (showAllAgents)="navigate('agents')"
                    (showAllHistory)="navigate('history')"
                />
            </div>
        }
        <!-- /SETTINGS OVERLAY -->

        <!-- AGENTS LIST OVERLAY -->
        @if (agentsListRendered()) {
            <div
                class="absolute inset-0 z-20 transition-transform ease-in-out"
                [attr.inert]="activeView() !== 'agents' ? '' : null"
                [ngClass]="{
                    'translate-x-0': showAgentsList(),
                    'translate-x-full': !showAgentsList(),
                }"
                [style.transition-duration.ms]="ANIMATION_DURATION"
            >
                <interacta-ai-convo-agents-panel
                    class="size-full"
                    (agentSelected)="onAgentSelected($event)"
                    (back)="back()"
                />
            </div>
        }
        <!-- /AGENTS LIST OVERLAY -->

        <!-- HISTORY LIST OVERLAY -->
        @if (historyListRendered()) {
            <div
                class="absolute inset-0 z-20 transition-transform ease-in-out"
                [attr.inert]="activeView() !== 'history' ? '' : null"
                [ngClass]="{
                    'translate-x-0': showHistoryList(),
                    'translate-x-full': !showHistoryList(),
                }"
                [style.transition-duration.ms]="ANIMATION_DURATION"
            >
                <interacta-ai-convo-history-panel
                    class="size-full"
                    (back)="back()"
                    (deleteClick)="onDeleteItem($event)"
                    (itemClick)="onHistoryItemClick($event)"
                    (renameClick)="onRenameItem($event)"
                />
            </div>
        }
        <!-- /HISTORY LIST OVERLAY -->
    </div>
    <!-- /BODY -->

    <interacta-ai-convo-rename-dialog
        [isOpen]="renamingItem() !== null"
        [title]="renameDialogTitle()"
        (closing)="renamingItem.set(null)"
        (editTitle)="onRenameConfirm($event)"
    />
</interacta-ai-panel-layout>
